import React from 'react';
import Firebase from './firebase';

const FirebaseContext = React.createContext<Firebase | null>(null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ComponentClass = (props: React.Props<any>) => JSX.Element;

export const withFirebase = (Component: typeof React.Component): ComponentClass => props => (
    <FirebaseContext.Consumer>
        {firebase => <Component {...props} firebase={firebase} />}
    </FirebaseContext.Consumer>
);

export default FirebaseContext;



// WEBPACK FOOTER //
// ./src/Firebase/context.tsx